import React, { useCallback } from 'react';
import UDMainLayout from 'modules/ud-ui/layout/main';
import TourneyComponentsCreateForm from '../../components/create-form';
import { TourneyEncoded } from 'modules/tourneys/domain/interfaces/TourneyEncoded';
import UDBreadcrumbs from '../../../../ud-ui/components/breadcrumbs';

const TourneyPagesCreatePage = () => {
  const onSave = useCallback((data: Partial<TourneyEncoded>) => {}, []);

  const breadcrumbsItems = [{
    label: 'Создание турнира',
    to: ''
  }];

  const breadcrumbs = (
    <UDBreadcrumbs
      className="my-10"
      breadcrumbs={breadcrumbsItems}
    />
  );

  return (
    <UDMainLayout headerContent={breadcrumbs}>
      <TourneyComponentsCreateForm onSubmit={onSave} />
    </UDMainLayout>
  );
};

export default TourneyPagesCreatePage;
